import { useEffect, useState, useRef } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import basePCUrl from '../../../Globals';
var baseUrl = basePCUrl + 'AnalyzeLink/GetLinkDetailAdmin';

export const useFetchGlobalAndCompanyStatistics = (finalUrl) => {
  const { getAccessTokenSilently } = usePortalAuth();

  const [state, setState] = useState({
    companyStatistics: [],
    globalStatistics: [],
    isLoadingGC: true,
  });

  const useIsMount = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
      isMountRef.current = false;
    }, []);
    return isMountRef.current;
  };

  const isMount = useIsMount();

  ////////MAKE NOTE - LAST 30 DAYS////////
  //console.log(finalUrl);

  const fetchAdditionalLinkAnalysis = async () => {
    // setState({ data: null, domainDetails: null, isLoading: true });

    const token = await getAccessTokenSilently();
    const headers = {
      Authorization: `Bearer ${token}`,
      Action: 'linkAnalysis',
      link: finalUrl,
      'Content-Type': 'application/json',
    };

    fetch(basePCUrl, {
      method: 'get',
      headers: headers,
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }

        response.json().then((data) => {
          if (data.errorMessage != undefined) {
            setState({
              companyStatistics: { companySeens: 0, companyClicks: 0 },
              globalStatistics: { globalSeens: 0, globalClicks: 0 },
              isLoadingGC: false,
            });
          } else {
            setState({
              companyStatistics: data.companyStatistics,
              globalStatistics: data.globalStatistics,
              isLoadingGC: false,
            });
          }
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  useEffect(() => {
    setState({ companyStatistics: null, globalStatistics: null, isLoadingGC: null });

    if (!isMount)  {
      fetchAdditionalLinkAnalysis();
    }
  }, [finalUrl]);

  return state;
};
export default useFetchGlobalAndCompanyStatistics;
